import React from 'react'
import { useSelector } from 'react-redux'

export default function DashboardPage() {
  const {csrf_token} = useSelector((state) => state.user)
  console.log("csrf in dashboard", csrf_token)
  return (
    <div>
      Coming Soon
    </div>
  )
}
